<template>
  <a-modal
    v-model:open="open"
    title="Traffic Allocation Edit"
    :footer="null"
    :width="480"
    @cancel="onCancel"
  >
    <div class="traffic-list">
      <div
        v-for="(item, index) in allocationList"
        :key="item.advertiserAffiliateRelationId"
        class="traffic-item"
      >
        <span class="name">{{ index + 1 }}. {{ item.name }}</span>
        <a-input-number
          v-model:value="item.percent"
          :min="0"
          :max="100"
          :controls="false"
          :formatter="(value) => `${value}%`"
          :parser="(value) => value.replace('%', '')"
        />
      </div>
    </div>
    <div class="notice">
      <div class="notice-title">Notice:</div>
      <div>All affiliates are listed regardless of status. Please configure a weight for each affiliate. </div>
    </div>
    <div class="footer">
      <a-button
        type="primary"
        @click="onSave"
      >
        SAVE
      </a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { advertiser } from '../server/index'

import { message } from 'ant-design-vue'

const props = defineProps({
  advertiserId: { type: [String, Number], required: true },
  affiliates: { type: Array, default: () => [] },
  allocations: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['cancel', 'save'])

const open = ref(true)
const allocationList = ref([])

const initList = () => {
  allocationList.value = props.affiliates.map((item) => ({
    advertiserAffiliateRelationId: item.id,
    affiliateId: item.affiliateId,
    name: item.affiliate?.name || '-',
    percent: item.percent ?? props.allocations[item.id] ?? 0,
  }))
}

watch(() => props.affiliates, initList, { immediate: true, deep: true })

const onCancel = () => {
  emit('cancel')
}

const onSave = () => {
  // const total = allocationList.value.reduce((sum, item) => sum + (Number(item.percent) || 0), 0)
  // if (total !== 100) {
  //   message.error('The total percentage across all affiliates must equal 100%.')
  //   return
  // }
  const result = {
    advertiserId: Number(props.advertiserId) || props.advertiserId,
    items: allocationList.value.map((item) => ({
      advertiserAffiliateRelationId: item.advertiserAffiliateRelationId,
      affiliateId: item.affiliateId,
      percent: Number(item.percent) || 0,
    })),
  }
  console.log(result,'result')
  advertiser.saveTrafficAllocation(result).then(res => {
    if (res.success) {
      message.success('Saved successfully')
      emit('save', result)
    } else {
      message.error(res.error)
    }
  })
  // emit('save', result)
}
</script>

<style lang="less" scoped>
.traffic-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.traffic-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  .name {
    flex: 1;
    color: rgba(0, 0, 0, 0.88);
  }
  :deep(.ant-input-number) {
    width: 100px;
  }
}
.notice {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  line-height: 1.8;
  margin-bottom: 24px;
  .notice-title {
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 4px;
  }
}
.footer {
  text-align: center;
}
</style>
